import { __decorate } from "tslib";
import { Action, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import { Api } from '@/domains/api';
let ControllerStore = class ControllerStore extends VuexModule {
    constructor() {
        super(...arguments);
        this.controllers = [];
        this.updateResult = null;
    }
    async fetch() {
        const response = await Api.Controllers.Get();
        return {
            controllers: response.data,
        };
    }
    async updateVersion(payload) {
        await Api.Controllers.UpdateVersion(payload);
    }
    async fetchUpdateResult(id) {
        const response = await Api.Controllers.GetUpdateResult(id);
        return {
            updateResult: response.data,
        };
    }
};
__decorate([
    MutationAction({ mutate: ['controllers'] })
], ControllerStore.prototype, "fetch", null);
__decorate([
    Action
], ControllerStore.prototype, "updateVersion", null);
__decorate([
    MutationAction({ mutate: ['updateResult'] })
], ControllerStore.prototype, "fetchUpdateResult", null);
ControllerStore = __decorate([
    Module({
        namespaced: true,
    })
], ControllerStore);
export default ControllerStore;
export * from './type';
